<template>
    <section class="bg-[#76568A] py-16 text-center text-white mt-20 pb-32">
      <!-- Título -->
      <h2 class="text-2xl md:text-3xl font-semibold mb-2 mt-10">Painéis exclusivos que você somente encontra aqui!</h2>
      <p class="text-sm text-gray-100 mb-12">Conheça um pouco dos nossos diferenciais!</p>
  
      <!-- Grid de cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto px-4">
        <div
          v-for="(item, index) in paineis"
          :key="index"
          class="bg-white text-gray-800 rounded-2xl shadow-md p-12 hover:shadow-lg transition duration-300 flex flex-col items-center justify-between"
        >
          <img :src="item.icone" :alt="item.titulo" class="h-40 mb-6" />
          <h3 class="text-lg font-bold mb-2 text-center">{{ item.titulo }}</h3>
          <p class="text-sm text-gray-600 leading-relaxed text-center">{{ item.descricao }}</p>
        </div>
      </div>
    </section>
  </template >
  
  <script setup>
  const paineis = [
    {
      titulo: 'Integrator Node.js',
      icone: '/icones-painel/node.svg',
      descricao: 'Painel exclusivo para deploy de aplicações Node.js independentes, qualquer versão, com PM2 e visualização de logs.',
    },
    {
      titulo: 'Integrator Spring Boot',
      icone: '/icones-painel/spring.svg',
      descricao: 'Painel exclusivo para deploy do Spring Boot Standalone, mapeamento, logs, memória, stop e start.',
    },
    {
      titulo: 'Integrator Java EE',
      icone: '/icones-painel/java.svg',
      descricao: 'Painel exclusivo para instalação, execução e deploy em Tomcat, Jetty, Glassfish, Wildfly, Payara com uma JDK em qualquer versão.',
    },
    {
      titulo: 'Deploy Automatizado via Git',
      icone: '/icones-painel/git.svg',
      descricao: 'Deploy automatizado de seus aplicativos Node.js com GIT privado simples e rápido.',
    },
    {
      titulo: 'Armazenamento',
      icone: '/icones-painel/ssd.svg',
      descricao: 'Infraestrutura moderna com discos SSD NVMe, em RAID 10, dando segurança e garantia no armazenamento de seus dados.',
    },
    {
      titulo: 'Proteção DDoS',
      icone: '/icones-painel/ddos.svg',
      descricao: 'Nossa infraestrutura é protegida no nível da rede. Você pode ter certeza de que suas instâncias serão resilientes aos ataques mais populares.',
    },
  ]
  </script>
  